import axios from 'axios'
import { AUTH_HEADERS } from '../utils/config'
export default {
  get (limit, offset) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}workOrderImage/all?limit=${limit}&offset=${offset}`, AUTH_HEADERS())
  },
  getByTask (taskId, size) {
    size = size || 'original'
    return axios.get(`${process.env.VUE_APP_BASE_URL}workOrderImage/task/${taskId}?size=${size}`, AUTH_HEADERS())
  },
  getImage (id, size) {
    // size = size || 'original'
    size = 'original' // default set to original for now, TODO: debug on staging site
    return axios.get(`${process.env.VUE_APP_BASE_URL}workOrderImage/${id}?size=${size}`, AUTH_HEADERS())
  },
  create (image) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}workOrderImage`, image, AUTH_HEADERS())
  },
  update (image) {
    return axios.put(`${process.env.VUE_APP_BASE_URL}workOrderImage/${image.id}`, image, AUTH_HEADERS())
  },
  upload (object) {
    let formData = new FormData()
    formData.append('file', object.file)
    return axios.put(`${process.env.VUE_APP_BASE_URL}workOrderImage/upload/${object.id}`, formData, AUTH_HEADERS())
  },
  uploadCreate (object) {
    let formData = new FormData()
    formData.append('file', object.file)
    return axios.post(`${process.env.VUE_APP_BASE_URL}workOrderImage/createUpload?workOrderTaskId=${object.workOrderTaskId}&userId=${object.userId}&documentTypeId=${object.documentTypeId}`, formData, AUTH_HEADERS())
  },
  deleteImage (id) {
    return axios.delete(`${process.env.VUE_APP_BASE_URL}workOrderImage/remove/${id}`, AUTH_HEADERS())
  }
}
